module.exports = __webpack_public_path__ + "img/message-question.672ae0f9.svg";